<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Filter Tags</h4>

  <button
    data-dd-action-name="filter-tag-modal.close-button"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('exit')"
  ></button>
</div>

<form (validSubmit)="onSubmit()">
  <div class="modal-body">
    <div>
      <p class="mt-1">Please select the tag to filter.</p>
      <div class="row gx-2 flex-grow-1 mb-3">
        <div class="col vertical">
          <select
            data-dd-action-name="filter-tag-modal.tag-select"
            class="form-select"
            [ngModel]="activeTag"
            (ngModelChange)="onChange($event)"
            name="tag"
          >
            @for (tag of tags; track tag) {
              <option [ngValue]="tag">
                {{ tag.name }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
    @if (activeTag) {
      <div>
        <p class="mt-1">Filtered values:</p>
        @for (value of activeTag.values; track value) {
          <div class="row gx-2 Control ng-star-inserted">
            <div class="col Control-input">
              <div class="row gx-2 flex-grow-1 mb-1">
                <div class="input-group mb-1">
                  <input
                    data-dd-action-name="filter-tag-modal.value-input"
                    type="text"
                    appFormControl
                    name="value"
                    [value]="value.value"
                    disabled
                  />
                  <label class="input-group-text form-check pt-0 px-2 mb-0">
                    <input
                      data-dd-action-name="filter-tag-modal.value-checkbox"
                      type="checkbox"
                      class="form-check-input ms-0"
                      name="isEnabled"
                      [checked]="isSelected(value)"
                      (click)="toggleValue(value)"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="modal-footer">
    <button
      data-dd-action-name="filter-tag-modal.cancel-button"
      type="button"
      class="btn btn-outline ms-2"
      (click)="modal.dismiss('exit')"
    >
      Cancel
    </button>

    <button
      data-dd-action-name="filter-tag-modal.save-button"
      type="submit"
      class="btn btn-primary ms-2"
    >
      <i-lucide name="save"></i-lucide>
      Save
    </button>
  </div>
</form>
